import { NgModule } from '@angular/core';
import { NgbTimeAdapter, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { AutosizeModule } from 'ngx-autosize';
import { AddressListDialogComponent } from './address-list-dialog/address-list-dialog.component';
import { AliasDialogComponent } from './alias-dialog/alias-dialog.component';
import { CancelTaskDialogComponent } from './cancel-task-dialog/cancel-task-dialog.component';
import { CategoryTreeDialogComponent } from './category-tree-dialog/category-tree-dialog.component';
import { ChangeRepoNameComponent } from './change-repo-name-dialog/change-repo-name.component';
import { ClipboardDataDialogComponent } from './clipboard-data-dialog/clipboard-data-dialog.component';
import { CloneServiceDataDialogComponent } from './clone-service-data-dialog/clone-service-data-dialog.component';
import { ConfirmationWithCheckDialogComponent } from './confirm-with-check-dialog/confirm-with-check-dialog.component';
import { ConfirmationWithCountdownDialogComponent } from './confirm-with-countdown-dialog/confirm-with-countdown-dialog.component';
import { DialogsService } from './dialogs.service';
import { DTypeMasterDataDialogComponent } from './dtype-masterdata-dialog/dtype-masterdata-dialog.component';
import { EditServiceJobDialogComponent } from './edit-service-job-dialog/edit-service-job-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { IconPickerDialogComponent } from './iconpicker-dialog/iconpicker-dialog.component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { LocationChangeDialogComponent } from './location-change-dialog/location-change-dialog.component';
import { MissionUsersEventsDialogComponent } from './mission-users-events-dialog/mission-users-events-dialog.component';
import { ModifyTaskTypeDialogComponent } from './modify-task-type-dialog/modify-task-type-dialog.component';
import { MoreInfoEventsDialogComponent } from './more-info-events-dialog/more-info-events-dialog.component';
import { NewFormReplyDialog } from './new-form-reply-dialog/new-form-reply-dialog.component';
import { NewMasterDataDialog } from './new-masterdata-dialog/new-masterdata-dialog.component';
import { NewTaskTypeDataDialogComponent } from './new-tasktype-dialog/new-tasktype-dialog.component';
import { PreviewFileDialogComponent } from './preview-file-dialog/preview-file-dialog.component';
import { RequestGoLiveDialogComponent } from './request-go-live-dialog/request-go-live-dialog.component';
import { ResourcesSelectAreaDialog } from './resources-select-area-dialog/resources-select-area-dialog.component';
import { ScheduleGoLiveDialogComponent } from './schedule-go-live-dialog/schedule-go-live-dialog.component';
import { SearchResourcesDialogComponent } from './search-resources-dialog/search-resources-dialog.component';
import { SelectGoalDateComponent } from './select-goal-date/select-goal-date-dialog.component';
import { TaskDetailDialogComponent } from './task-detail-dialog/task-detail-dialog.component';
import { TaskFormDialogComponent } from './task-form-dialog/task-form-dialog.component';
import { TaskGoalDialogComponent } from './task-goal-dialog/task-goal-dialog.component';
import { TaskTypeFormDialogComponent } from './task-type-form-dialog/task-type-form-dialog.component';
import { TaskTypeGoalDialogComponent } from './task-type-goal-dialog/task-type-goal-dialog.component';
import { UploadExcelDialogComponent } from './upload-excel-dialog/upload-excel-dialog.component';
import { UserPrivilegeDialogComponent } from './user-privilege-dialog/user-privilege-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { FuseCardModule } from '../../@fuse/components/card/card.module';
import { FuseScrollbarModule } from '../../@fuse/directives/scrollbar/scrollbar.module';
import { DTypeModule } from '../core/dtype/dtype.module';
import { ComponentsModule } from '../core/components/components.module';
import { EditTaskSidebarComponent } from '../core/components/task-sidebar/edit-task-sidebar/edit-task-sidebar.component';
import { NgbTimeStringAdapter } from '../core/config/app.config';
import { LayoutModule } from '../layout/layout.module';

@NgModule({
    declarations: [
        AddressListDialogComponent,
        AliasDialogComponent,
        ClipboardDataDialogComponent,
        ConfirmationWithCheckDialogComponent,
        ConfirmationWithCountdownDialogComponent,
        ChangeRepoNameComponent,
        TaskTypeFormDialogComponent,
        DTypeMasterDataDialogComponent,
        EditServiceJobDialogComponent,
        ErrorDialogComponent,
        IconPickerDialogComponent,
        InfoDialogComponent,
        LocationChangeDialogComponent,
        NewFormReplyDialog,
        NewMasterDataDialog,
        NewTaskTypeDataDialogComponent,
        SearchResourcesDialogComponent,
        ModifyTaskTypeDialogComponent,
        CancelTaskDialogComponent,
        MoreInfoEventsDialogComponent,
        TaskFormDialogComponent,
        CategoryTreeDialogComponent,
        MissionUsersEventsDialogComponent,
        PreviewFileDialogComponent,
        CloneServiceDataDialogComponent,
        RequestGoLiveDialogComponent,
        ScheduleGoLiveDialogComponent,
        SelectGoalDateComponent,
        TaskTypeGoalDialogComponent,
        TaskGoalDialogComponent,
        TaskDetailDialogComponent,
        UploadExcelDialogComponent,
        UserPrivilegeDialogComponent,
    ],
    imports: [
        SharedModule,
        TranslocoModule,
        FuseCardModule,
        FuseScrollbarModule,
        DTypeModule,
        LayoutModule,
        ComponentsModule,
        AutosizeModule,
        NgbTimepickerModule,
        EditTaskSidebarComponent,
        ResourcesSelectAreaDialog
    ],
    providers: [
        DialogsService,
        { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }
    ]
})
export class DialogsModule { }
